import React from 'react';
import PropTypes from "prop-types";

// https://www.w3schools.com/bootstrap5/bootstrap_modal.php
function ModalImage({ modalTitle, imgSrc, imgAlt, imgWidth }) {
  //buttonText,
  return (
    <>
      {/*
      <div className="container mt-3">
        <button
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#myModal"
        >
          {buttonText}
        </button>
      </div>
      */}

      <div className="modal fade" id="myModal">
        <div className="modal-dialog">
          {" "}
          {/* modal-fullscreen */}
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{modalTitle}</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>{" "}
              {/* kruisje rechtsboven */}
            </div>

            <div className="modal-body">
              <img src={imgSrc} alt={imgAlt} width={imgWidth} />
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

ModalImage.propTypes = {
  //buttonText: PropTypes.string,
  modalTitle: PropTypes.string,
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string,
  imgWidth: PropTypes.string,
};

export default ModalImage;